export default __webpack_public_path__ + "static/songaday-b82b50c4c8200bf3742b884711f8623c.jpg";